/* import __COLOCATED_TEMPLATE__ from './popover-menu-item-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import { type TicketField } from 'embercom/objects/standalone/data-fields/common';
import type ExternalFieldIdentifier from 'embercom/models/standalone/external-field-identifier';
import { type IntercomFieldType } from 'embercom/models/standalone/external-field-identifier';
import type Attribute from 'embercom/models/attribute';

export interface PopoverMenuItemTooltipArgs {
  tooltipAttrs: {
    attribute?: Attribute | { name: string };
    field?: ExternalFieldIdentifier | TicketField;
    tooltipText?: string;
  };
}

const CATEGORY_MAP = {
  conversation: {
    label: 'conversation-category',
    icon: 'conversation',
  },
  user: {
    label: 'people-category',
    icon: 'person',
  },
  company: {
    label: 'company-category',
    icon: 'company',
  },
} as Record<IntercomFieldType, { label: string; icon: InterfaceIconName }>;

export default class PopoverMenuItemTooltip extends Component<PopoverMenuItemTooltipArgs> {
  get attribute() {
    return this.args.tooltipAttrs.attribute;
  }

  get field() {
    return this.args.tooltipAttrs.field;
  }

  get category(): IntercomFieldType {
    if (this.field) {
      return this.field.intercomFieldType;
    } else if (this.attribute && 'isUser' in this.attribute && this.attribute.isUser) {
      return 'user';
    } else if (this.attribute && 'isCompany' in this.attribute && this.attribute.isCompany) {
      return 'company';
    } else {
      return 'conversation';
    }
  }

  get categoryIcon() {
    return CATEGORY_MAP[this.category].icon;
  }

  get categoryLabel() {
    return CATEGORY_MAP[this.category].label;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::PopoverMenu::Standalone::PopoverMenuItemTooltip': typeof PopoverMenuItemTooltip;
    'workflows/graph-editor/popover-menu/standalone/popover-menu-item-tooltip': typeof PopoverMenuItemTooltip;
  }
}
